module.exports = __webpack_public_path__ + "img/Vet-clinic.5c1e6eba.svg";